export default __webpack_public_path__ + "b19b75505d6035746afe98c1a3436acc.png";